/**
 * Table row column enum map to determine how many columns to render in a table row
 */
const TableRowColumnAmount = {
  TWO_COLUMNS: 'TwoColumnTableRowBlock',
  THREE_COLUMNS: 'ThreeColumnTableRowBlock',
};

export default TableRowColumnAmount;
